import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Paper } from '@material-ui/core';
import {useTranslation} from 'react-i18next'
import UserService from '../../../../../services/UserService/UserService';

const useStyles = makeStyles({
    table: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        boxSizing: 'border-box',
        border: '1px solid #BDBBBB',
        paddingBottom: '40px'
    },
    tableHeader: {
        textDecoration: 'underline',
        padding: '20px 0 0 25px',
        fontSize: '20px',
        fontWeight: 500
    },
    tableSubHeader:{
        padding: '20px 0 30px 25px',
        fontSize: '16px'
    },
    roleTableHeader: {
        height: '35px',
        color: '#fff',
        padding: '7px 20px',
        backgroundColor: '#001128',
        borderRadius: '6px 6px 0px 0px'
    },
    tableContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        boxSizing: 'border-box',
        padding: '0 25px'
    },
    tableRow: {
        padding: '15px 0 15px 0',
        display: 'flex'
    },
    tableBody: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        maxHeight: '150px'
    },
    imgDiv: {
        marginRight: 20
    },
    nameCell: {
        fontWeight: '600',
        fontSize: '14px',
        marginRight: '10px',
        minWidth: 50
    },
    valueCell: {
        fontSize: '14px',
        fontWeight: '400'
    },
    roleTable: {
        margin: '0px 25px',
        border: '1px solid #BDBBBB',
        borderRadius: '7px'
    },
    roleBody: {
        padding: '0 20px',
        height: '150px',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap'
    }
});

export function createData(name, value) {
    return { name, value };
}
let rowLeft = [];

function AccountDetails(props) {

    const classes = useStyles();
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const urlElements = window.location.href.split('/');
        let userID = urlElements.length > 0 ? urlElements[urlElements.length - 1] : "0"
        UserService.getUserByID(userID).then((response) => {
            rowLeft = [
                createData('CONTENT.USER.FIRST-NAME', response.data.data.first_name),
                createData('CONTENT.USER.LAST-NAME', response.data.data.last_name),
                createData('CONTENT.USER.E-MAIL', response.data.data.user_email),
                createData('CONTENT.USER.STATUS', response.data.data.status != null ? 'active' : 'passive'),
                createData('CONTENT.USER.DOMAIN', response.data.data.domain === null ? t('CONTENT.USER.DOMAIN') : response.data.data.domain)
            ];
            props.setRoles(response.data.data.roles);
            props.setUser(response.data.data.id);
            setIsLoaded(true);
        });
    }, []);

    const {t} = useTranslation()

    return (
        <Paper className={classes.table} data-test='account-detail-comp'>
            <Box className={classes.tableHeader}>{t('CONTENT.USER.USER-DETAILS')}</Box>
            <Box className={classes.tableSubHeader}>{t('CONTENT.USER.USER-DETAILS-SUB-HEADER')}</Box>
            {isLoaded ? (
                <Paper className={classes.roleTable}>
                    <Box className={classes.roleTableHeader}>{t('CONTENT.USER.USER-DETAILS')}</Box>
                     <div className={classes.roleBody}>
                        {rowLeft.map((row) => (
                            <Box key={row.name} className={classes.tableRow} data-test='table-row'>
                                <Box className={classes.nameCell}>{t(row.name)}</Box>
                                <Box className={classes.valueCell}>{row.value}</Box>
                            </Box>
                        ))}
                     </div>
                </Paper>
            ) : null}
        </Paper>
    );
}

export default AccountDetails;
